<template lang="pug">
el-form-item(label-width="0")
  el-autocomplete.width-full(size="mini", v-model.trim="data.contentFormat", :fetch-suggestions="querySearch")
</template>
<script>
import { baseMixin } from "./index.js";
export default {
  mixins: [baseMixin],
  computed: {
    templates() {
      return this.timeFormats.map(({ cnName }) => cnName);
    }
  },
  methods: {
    querySearch(val, cb) {
      const { templates } = this;
      const list = val ? templates.filter((str) => str.indexOf(val) >= 0) : templates;
      cb(list.map((str) => ({ value: str, label: str })));
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
